import { render, staticRenderFns } from "./ftc-modal-button-footer.vue?vue&type=template&id=24c845a2"
import script from "./ftc-modal-button-footer.vue?vue&type=script&lang=js"
export * from "./ftc-modal-button-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports